import type { ZoraTheme } from '../../types/theme';

export const zoraDefaultTheme: ZoraTheme = {
  id: 'zora',
  name: 'ZORA',
  appCategory: 'developer_tools',
  primaryColor: '#0f766e',
  harmony: 'analogous',
};
